module.exports = __webpack_public_path__ + "static/media/preview.d41b337f.png";